import React, { useEffect } from "react";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum | Rechtsanwalt Sindros";
  }, []);

  return (
    <div>
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h1
            className="text-4xl font-bold mb-12"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Impressum
          </h1>

          <div className="space-y-8" style={{ color: "#555555" }}>
            <div>
              <p className="text-sm font-medium mb-4" style={{ color: "#777777" }}>
                Angaben gemäß § 5 TMG / Art. 5 E-Commerce-Richtlinie
              </p>
              <p className="text-base leading-relaxed">
                Rechtsanwalt Sindros
                <br />
                Kanzlei für Internetrecht &amp; Reputationsmanagement
              </p>
              <p className="text-base leading-relaxed mt-4">
                c/o THE PUMA GROUP
                <br />
                Arxaiologikou Mouseiou 17
                <br />
                54640 Thessaloniki
                <br />
                Griechenland
              </p>
              <p className="text-base leading-relaxed mt-4">
                Steuernummer: EL801922203
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Kontakt
              </h2>
              <p className="text-base leading-relaxed">
                E-Mail: info@fairebewertungen.de
                <br />
                Telefon: 0178-4660549
                <br />
                WhatsApp: 0178-4660549
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Berufsbezeichnung
              </h2>
              <p className="text-base leading-relaxed">
                Rechtsanwalt (Δικηγόρος), verliehen in Griechenland
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Zuständige Rechtsanwaltskammer
              </h2>
              <p className="text-base leading-relaxed">
                Rechtsanwaltskammer Thessaloniki (Δικηγορικός Σύλλογος
                Θεσσαλονίκης)
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Berufsrechtliche Regelungen
              </h2>
              <p className="text-base leading-relaxed">
                Griechischer Anwaltskodex (Κώδικας Δικηγόρων, Gesetz 4194/2013)
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Streitschlichtung
              </h2>
              <p className="text-base leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  style={{ color: "#2E75B6" }}
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="text-base leading-relaxed mt-2">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
              <p className="text-base leading-relaxed mt-2">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Haftung für Inhalte
              </h2>
              <p className="text-base leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
                jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die
                auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-base leading-relaxed mt-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
                diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Haftung für Links
              </h2>
              <p className="text-base leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich.
              </p>
            </div>

            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                Urheberrecht
              </h2>
              <p className="text-base leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Downloads
                und Kopien dieser Seite sind nur für den privaten, nicht
                kommerziellen Gebrauch gestattet.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
